(() => {
  const TARGET_VARIANT_ID = "56426878992732";
  const TARGET_HANDLE = "divine-puff";
  const TARGET_PRODUCT_URL = "/it-it/products/divine-puff";

  // helper: nasconde nodi con display:none !important
  function hideAll(root, selectors) {
    selectors.forEach((sel) => {
      root.querySelectorAll(sel).forEach((el) => {
        el.style.setProperty("display", "none", "important");
      });
    });
  }

  // 1) LISTING: bottone add-to-cart -> redirect alla pagina prodotto
  function listingRedirectAndButtonText() {
    document
      .querySelectorAll('form[action*="/cart/add"].product-card-item__form')
      .forEach((form) => {
        const variantInput = form.querySelector('input[name="id"]');
        if (!variantInput || variantInput.value !== TARGET_VARIANT_ID) return;

        // evita bind multipli
        if (form.dataset.mwRedirectBound === "1") return;
        form.dataset.mwRedirectBound = "1";

        form.addEventListener(
          "submit",
          (e) => {
            e.preventDefault();
            window.location.href = TARGET_PRODUCT_URL;
          },
          { capture: true }
        );

        const btn = form.querySelector('button[type="submit"]');
        if (btn) {
          const text = btn.querySelector(".btn--text");
          if (text) text.textContent = "Scopri il prodotto";
          btn.setAttribute("aria-label", "Scopri il prodotto");
        }
      });
  }

  // 2) LISTING: nasconde il prezzo nel product-card di divine-puff
  function hideListingCardPrice() {
    document
      .querySelectorAll(`product-card[data-la-dn-product-handle="${TARGET_HANDLE}"]`)
      .forEach((card) => {
        hideAll(card, [
          ".product-price__wrapper",
          "[data-la-dn-price]"
        ]);
      });
  }

  // 3) CART DRAWER: nasconde tutto il blocco prezzi per la riga della variante target
  function hideDrawerPricesForVariant() {
    document
      .querySelectorAll(`li[data-la-dn-cart-item-key^="${TARGET_VARIANT_ID}:"]`)
      .forEach((row) => {
        hideAll(row, [
          ".cart__drawer__prices",
          ".cart__drawer__discounted-prices",
          "[data-la-dn-cart-item-line-price]"
        ]);
      });
  }

  // 4) ICONA QUICK VIEW: nasconde bottone solo per divine-puff
  function hideQuickViewIconOnCard() {
    document
      .querySelectorAll(`product-card[data-la-dn-product-handle="${TARGET_HANDLE}"]`)
      .forEach((card) => {
        // bottone quick view
        card.querySelectorAll('button[quick-view-button]').forEach((btn) => {
          btn.style.setProperty("display", "none", "important");
          btn.disabled = true;
          btn.setAttribute("aria-hidden", "true");
          btn.setAttribute("tabindex", "-1");
        });

        // wrapper che contiene i quick buttons
        card.querySelectorAll(".quick-buttons-wrapper").forEach((wrap) => {
          wrap.style.setProperty("display", "none", "important");
        });
      });
  }

  function runAll() {
    listingRedirectAndButtonText();
    hideListingCardPrice();
    hideDrawerPricesForVariant();
    hideQuickViewIconOnCard();
  }

  // primo giro
  document.addEventListener("DOMContentLoaded", runAll);

  // supporto per aggiornamenti AJAX (cart drawer / griglia prodotti che si ricarica)
  let raf = null;
  const observer = new MutationObserver(() => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      runAll();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
